module.exports = __webpack_public_path__ + "static/media/iconImport2.ddeddc21.svg";